<div
  *ngIf="isPriceInvalid"
  class="top: 136px; position: fixed;left: 0;z-index: 10;--tw-bg-opacity: 1;background-color: rgb(247 248 249 / var(--tw-bg-opacity, 1));padding-top: 180px;"
>
  <div class="p-2 text-center bg-vtmn-play-content-brand text-white">
    <p class="mb-1" [innerHTML]="invalidPriceText"></p>
  </div>
</div>
<app-organizer-shared-layout-dashboard [hasHeader]="hasHeader">
  <app-organizer-shared-header
    class="col-span-12 mb-4 lg:col-span-6 lg:mb-3"
    [title]="'organizer.timeslot.pre_schedule.page.title' | translate"
    [backLink]="backLink"
    [backLinkAriaLabel]="
      'a11y.organizer.timeslot.pre_schedule.page.title' | translate
    "
  ></app-organizer-shared-header>

  <div class="col-span-12 lg:col-span-5 lg:col-start-2">
    <app-activity-card
      [address]="activity.fullAddress"
      [picture]="picture"
      [title]="activity.name"
      [isLive]="activity.isLive"
      [currency]="activity.minPriceOffer?.currency"
      [variant]="activityCardVariant.SHADOWLESS"
      [duration]="activity.formattedDuration(dateLocale)"
      [visibility]="activity.visibility"
    >
    </app-activity-card>

    <app-divider
      [variant]="responsiveDividerVariant"
      class="block -mx-3 mb-6 xs:-mx-6 sm:-mx-9 lg:mx-0"
    ></app-divider>

    <app-organizer-shared-edit-section
      [title]="
        'organizer.timeslot.pre_schedule.maximum_group_size.label' | translate
      "
      [link]="'organizer.timeslot-edition.group-size' | localize"
    >
      <p>
        <ng-container *ngIf="!groupSize">
          {{ 'organizer.manage_timeslot.to_define' | translate }}
        </ng-container>
      </p>

      <p *ngIf="groupSize">
        {{
          'organizer.manage_timeslot.maximum_group_size_count'
            | translate: { maximumAttendeeCapacity: groupSize }
        }}
      </p>
    </app-organizer-shared-edit-section>

    <app-divider></app-divider>

    <app-organizer-shared-edit-section
      [title]="'organizer.timeslot.pre_schedule.plans.label' | translate"
      [link]="'organizer.timeslot-edition.offers' | localize"
    >
      <app-organizer-shared-display-plans
        *ngIf="!areOffersInvalid"
        [plans]="plans"
        [displayMode]="displayPlansMode"
        [plansMaximumCapacity]="plansMaximumCapacity"
      >
      </app-organizer-shared-display-plans>

      <p *ngIf="areOffersInvalid" class="text-red">
        {{ 'organizer.timeslot.pre_schedule.empty_offers.message' | translate }}
      </p>
    </app-organizer-shared-edit-section>

    <ng-container *ngIf="activity.isLive">
      <app-divider></app-divider>

      <app-organizer-shared-edit-live-url-section
        [liveUrl]="activity.liveUrl"
        [noteForAttendees]="activity.noteForAttendees"
        [link]="'organizer.timeslot-edition.live-url' | localize"
      ></app-organizer-shared-edit-live-url-section>
    </ng-container>

    <button
      app-vtmn-play-button
      type="button"
      class="w-full mt-4 md:w-auto"
      [type]="ctaButtonType.Button"
      [disabled]="isDisabled ? true : null"
      [attr.data-disabled]="isDisabled ? true : null"
      (click)="submit()"
    >
      {{ 'organizer.timeslot.pre_schedule.next' | translate }}
    </button>
  </div>
</app-organizer-shared-layout-dashboard>
